
let botStatus, params;
let userToken, audioLimit;
let emailValidate = false;
let browserStatus = false;
let commentPosition = 0;
let session = require('./session.js');
const webEncrypt  = require('./webchatEncryptDecrypt.js');


module.exports = {

  botData: function (data) {
    if (data != undefined && data.status != null && data.status != undefined) {
      botStatus = 0;

      if (botStatus == "1") {
        $("input:checkbox.bot-change").prop("checked", true);
      } else {
        $("input:checkbox.bot-change").prop("checked", false);
      }
    } else {
      botStatus = 0;
      $("input:checkbox.bot-change").prop("checked", true);
    }
  },
  adminName: function () {
    let settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
    let AdminUser = settings.adminUser;

    return AdminUser;
  },
  botStatus: function () {
    return 0;
  },
  setbrowserStatus: function (newbrowserStatus) {
    browserStatus = newbrowserStatus;
    return browserStatus;
  },
  getbrowserStatus: function () {
    return browserStatus;
  },
  getuserToken: function () {
    
    userToken =webEncrypt.getFromLocalStorageAndDecrypt('userToken');
    if(typeof userToken == 'undefined' || userToken == null){
      let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
      let username = loginUserInfo[0][0];
      module.exports.setSession(username);
      userToken =webEncrypt.getFromLocalStorageAndDecrypt('userToken');
    }
    return userToken;
  },
  setSession: async function(username){
    await session.setSession(username);
  },
  setemailvalidate: function (emailvalidate) {
    return emailvalidate;

  },
  getemailvalidate: function () {
    return emailValidate;
  },
  setCommentPosition: function (commentposition) {
    commentPosition = commentposition;
    return commentPosition;

  },
  setAudioLimit: function (audioLimit) {
    this.audioLimit = audioLimit;
    return this.audioLimit;
  },
  getAudioLimit: function () {
    return this.audioLimit;
  },
  options: function () {
    return params;
  },
  getCommentPosition: function () {
    return commentPosition;
  },
  // get keycloak logout url
  getKeycloakLogoutURL: function() {
    let clientId = window._env_.KeycloakClientId
    let idTokenHint = webEncrypt.getFromLocalStorageAndDecrypt('idToken'); // Id token which is getting from keyclock login
    
    localStorage.clear();

    let getUrl = window.location;
    let baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];

    let logoutUrl =  window._env_.KeycloakAuthURL + "/realms/" + window._env_.KeycloakRealm + "/protocol/openid-connect/logout?post_logout_redirect_uri=" + baseUrl + "&client_id=" + clientId + "&id_token_hint="+idTokenHint;

    return logoutUrl;
  }
};